import { getEnvironment } from '../util/env';

type KeyClockConfig = {
  issuer: string;
  clientId: string;
  redirectUri: string;
};

const keyClockConfig: KeyClockConfig = {
  issuer: `${getEnvironment(false)}/realms/planomatic/protocol/openid-connect`,
  clientId: 'planomatic-connect-client',
  redirectUri: `${location.origin}/callback`
};

export enum LoginConstants {
  ACCESS_TOKEN = 'accessToken',
  CODE_VERIFIER = 'codeVerifier',
  IS_REGISTER = 'isRegister',
  IDP_HINT = 'idpHint',
  NAVIGATE_TO = '/home/properties',
  NAVIGATE_TO_EXISTING_ORDER = '/home/orders',
  NAVIGATE_TO_EXISTING_PROPERTIES = '/home/properties',
  SELECT_ORG = '/select-organization',
  NAVIGATE_TO_ADDITIONAL_DETAILS = '/additional-details',
  CODE = 'code',
  CODE_CHALLENGE_METHOD = 'S256'
}

export default keyClockConfig;
